var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartAlign"},[_c('div',{style:({ height: _vm.screen_height + 'px' })},[_c('v-chart',{ref:_vm.chart_ref,staticClass:"performanceChart",attrs:{"option":_vm.graph_options,"autoresize":"","id":_vm.chart_id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }